import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import MEAL_TYPES from "../../dictionaries/mealTypes";

const mealTypeOptions = [
  <MenuItem key={`MealType-NULL`} value={""}>
    &nbsp;
  </MenuItem>,
  Object.keys(MEAL_TYPES).map((key) => (
    <MenuItem key={`MealType-${key}`} value={key}>
      {MEAL_TYPES[key]}
    </MenuItem>
  )),
];

const MealTypeSelectBox = ({ onChange, value, ...props }) => (
  <TextField
    fullWidth
    label="Meal Type"
    onChange={onChange}
    select
    value={value}
    {...props}
  >
    {mealTypeOptions}
  </TextField>
);

export default MealTypeSelectBox;
